module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Thin-eb720b78faaaf7555401c22d48daa1fd.otf";